import { Suspense, useState } from 'react';
import { Box, Paper } from '@mui/material';
import { FiltrosComponent } from '../components/filtrosComponent';
import { TablaPacComponent } from '../components/tablaPacComponent';
import { FormFiltersInterface } from '../interfaces/FormFiltersInterface';
import { useLocation } from 'react-router-dom';
import { breadcrumbItemsPac, breadcrumbItemsPat } from '../utils/BreadcrumbItems';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';

function ArchivoPac() {

    const location = useLocation();
    const breadcrumbItems = location.pathname.toLowerCase().trim().includes('pat') ? breadcrumbItemsPat : breadcrumbItemsPac
    
    const [formFilters, setFormFilters] = useState<FormFiltersInterface & { trigger: number }>(
        { fechaUF: null, fechaCobro: null, diaDescuento: null, valorUF: null, trigger: 0 }
    );

    const handleFilter = (formFilters: FormFiltersInterface) => setFormFilters(prev => ({...formFilters, trigger: prev.trigger + 1}));    

    return (
        <>
            <Suspense>
                <Breadcrumb items={ breadcrumbItems } />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>

                            <FiltrosComponent handleFilter={handleFilter} />

                            { formFilters?.diaDescuento && 
                                <TablaPacComponent
                                    key={formFilters.trigger}
                                    fechaUF={formFilters.fechaUF}
                                    fechaCobro={formFilters.fechaCobro}
                                    diaDescuento={formFilters.diaDescuento}
                                    valorUF={formFilters.valorUF}
                                /> 
                            }

                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>
        </>
    );
};

export default ArchivoPac;